var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeneralSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8544 6.21794C15.2244 5.91747 16.5191 5.92769 17.8942 6.24859L18.1173 7.35512C18.867 7.57635 19.413 7.79877 19.902 8.05865L21.1538 7.67133C21.716 8.03181 22.2333 8.44402 22.6832 8.89393C23.1669 9.37768 23.6073 9.93644 23.9843 10.5517L23.3816 11.4558C23.7585 12.1499 23.9887 12.7053 24.1535 13.2542L25.2829 13.8612C25.4281 14.5154 25.5017 15.172 25.5 15.8067C25.5 16.4863 25.4155 17.1951 25.2513 17.8947L24.188 18.1082C23.9587 18.8679 23.7264 19.4225 23.455 19.9208L23.8266 21.1553C23.4643 21.7207 23.0533 22.2362 22.6048 22.6847C22.1204 23.169 21.5609 23.6099 20.9479 23.9841L20.026 23.3699C19.3454 23.7308 18.8 23.9518 18.2603 24.1103L17.64 25.2838C16.984 25.4268 16.3298 25.5002 15.7012 25.5002C14.9992 25.5002 14.3046 25.4155 13.6044 25.2484L13.375 24.1133C12.6565 23.8897 12.1309 23.6678 11.6573 23.4115L10.3531 23.8314C9.78198 23.4676 9.26191 23.0535 8.8176 22.6057C8.33308 22.1249 7.89417 21.5643 7.51519 20.9514L8.17729 19.9562C7.83522 19.3082 7.62421 18.7907 7.4693 18.2809L6.21924 17.6506C6.07263 16.9884 5.99833 16.3272 6.00003 15.6955C5.99822 15.0185 6.08278 14.3124 6.25225 13.606L7.43083 13.367C7.64577 12.6581 7.85834 12.1411 8.10278 11.6773L7.66699 10.3554C8.03349 9.7812 8.44799 9.26063 8.89555 8.81651C9.37838 8.33182 9.93881 7.8906 10.552 7.5161L11.5271 8.16532C12.1906 7.80635 12.7177 7.58549 13.2342 7.42531L13.8544 6.21794Z",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 18.7505C17.4069 18.7505 18.75 17.4073 18.75 15.7504C18.75 14.0935 17.4069 12.7504 15.75 12.7504C14.0932 12.7504 12.75 14.0935 12.75 15.7504C12.75 17.4073 14.0932 18.7505 15.75 18.7505Z",
    stroke: "currentColor",
    strokeOpacity: 0.7,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralSettings);
export default __webpack_public_path__ + "static/media/general-settings.84fdcb49af7918099c988b30993553f7.svg";
export { ForwardRef as ReactComponent };